import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class PublicViewMetaInfo extends Vue {
  get appLoaded() {
    return this.$typedStore.primary.app.appLoaded
  }

  get useSecondaryAppInfo() {
    return (
      this.$typedStore.activeVisualisation.isSecondaryApp &&
      this.$typedStore.secondary.app.appLoaded
    )
  }

  get pageTitle() {
    if (this.useSecondaryAppInfo) {
      return this.$typedStore.secondary.app.pageTitle
    }
    return this.$typedStore.primary.app.pageTitle
  }

  get pageDescription() {
    if (this.useSecondaryAppInfo) {
      return this.$typedStore.secondary.app.pageDescription
    }
    return this.$typedStore.primary.app.pageDescription
  }

  get appName() {
    return this.$typedStore.primary.app.appName
  }

  get orgName() {
    return this.$typedStore.primary.app.orgName
  }

  get appLogo() {
    return this.$typedStore.primary.app.appLogo
  }

  get viewMetaInfo() {
    return this.appLoaded
      ? {
          title: this.pageTitle,
          meta: [
            { name: 'description', content: this.pageDescription },
            // Social Media Sharing Meta Data
            // OpenGraph data (Most widely used)
            { property: 'og:type', content: 'website' },
            { property: 'og:site_name', content: `${this.appName} - ${this.orgName}` },
            { property: 'og:title', content: this.pageTitle },
            { property: 'og:description', content: this.pageDescription },
            { property: 'og:image', content: this.appLogo },
            // Twitter card (inherits title, image, description)
            // { name: 'twitter:site', content: '@twitterHandle' },
            { name: 'twitter:image:alt', content: `${this.orgName} logo` },
            // Google / Schema.org markup:
            { itemprop: 'name', content: this.pageTitle },
            { itemprop: 'description', content: this.pageDescription },
            { itemprop: 'image', content: this.appLogo },
          ],
        }
      : {}
  }

  metaInfo() {
    return this.viewMetaInfo
  }
}
